import { Box, Grid, TextField, Stack, Button } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { DatePickerStyle, ErrorTypography, SecondaryTypography, StyledTypography } from '../../Theme';
import { ReactComponent as ContactDetailsIcon } from "../../Icons/ContactDetails.svg";
import axiosInstance from '../../Redux/AxiosInstance';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import PhoneInput from 'react-phone-input-2';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { ReactComponent as DatePickerIcon } from "../../Icons/Datepicker.svg";
import moment from 'moment';

function EditAdmin() {
    const navigate = useNavigate();
    const { userDetails } = useSelector((state) => state.Login);
    const location = useLocation();
    const { userId } = useParams();
    const { adminDetails } = location.state || {};
    console.log("adminDetails",adminDetails)

    const initialAdminData = {
        name: "",
        email: "",
        phone: "",
        role_id: "5",
        user_type: "company_users",
        accessstartdate: null,
        accessenddate: null,
        on_board_date: null,
        off_board_date: null,
        created_by: userDetails?.id || "",
    };

    const [adminData, setAdminData] = useState({ ...initialAdminData });
    console.log("data",adminData)
    const [loading, setLoading] = useState(false);
    const [errtext, seterrtext] = useState({});

    useEffect(() => {
        if (adminDetails) {
            setAdminData({
                name: adminDetails?.company_admin_name || "",
                email: adminDetails?.company_admin_email || "",
                phone: adminDetails?.company_admin_phone || "",
                role_id: "5",
                user_type: "company_users",
                accessstartdate: adminDetails?.on_board_date || null,
                accessenddate: adminDetails?.off_board_date || null,
                on_board_date: adminDetails?.company_admin_on_board_date || null,
                off_board_date: adminDetails?.company_admin_off_board_date || null,
                created_by: userDetails?.id || "",
            });
        }
    }, [adminDetails, userDetails]);

    const handleInputChange = (e, name) => {
        let fieldName;
        let fieldValue;

        if (name) {
            fieldName = name;

            if (["accessstartdate", "accessenddate", "on_board_date", "off_board_date"].includes(name)) {
                fieldValue = e ? moment(e.toDate ? e.toDate() : e).format("YYYY-MM-DD") : "";
            } else if (name === "phone") {
                fieldValue = e ? `+${e}` : "";
            } else {
                fieldValue = e;
            }
        } else {
            fieldName = e.target.name;
            fieldValue = e.target.value;
        }

        setAdminData((prev) => ({
            ...prev,
            [fieldName]: fieldValue,
        }));

        seterrtext((prev) => ({
            ...prev,
            [fieldName]: fieldValue ? "" : "",
        }));
    };

    const validateForm = () => {
        const newErrors = {};

        if (!adminData.name?.trim()) {
            newErrors.name = "Admin name is required";
        } else if (adminData.name.length > 70) {
            newErrors.name = "Admin name must be 70 characters or less";
        }

        if (!adminData.email?.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(adminData.email)) {
            newErrors.email = "Enter a valid email";
        }

        if (!adminData.phone?.trim()) {
            newErrors.phone = "Phone number is required";
        }

        if (!adminData.on_board_date) {
            newErrors.on_board_date = "Admin Onboard Date is required";
        }

        seterrtext(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleUpdate = async () => {
        if (!validateForm()) {
            return;
        }

        setLoading(true);
        try {
            const payload = {
                name: adminData.name,
                email: adminData.email,
                phone: adminData.phone,
                role_id: adminData.role_id,
                user_type: adminData.user_type,
                accessstartdate: adminData.accessstartdate,
                accessenddate: adminData.accessenddate,
                created_by: userDetails?.id,
                on_board_date: adminData.on_board_date,
                off_board_date: adminData.off_board_date,
            };

            const response = await axiosInstance.put(
                `${process.env.REACT_APP_API_URL}update_user/${adminDetails?.company_user_id}?updater_email=${userDetails?.email}`,
                payload
            );

            if (response?.data?.status === 200) {
                toast.success("Admin Updated Successfully");
                setTimeout(() => {
                    navigate(-1);
                }, 1000);
            }
            setLoading(false);
        } catch (error) {
            toast.dismiss();
            toast.error(error?.response?.data?.detail || "Something went wrong");
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer
                autoClose='3000'
                position="bottom-center"
                toastClassName="custom-toast"
                hideProgressBar={true}
            />
            <Box mt={3} component="div" borderRadius="8px">
                <Stack
                    direction="row"
                    alignItems="center"
                    gap="10px"
                    px="16px"
                    sx={{
                        height: "66px",
                        backgroundColor: "#FCFCFD",
                        border: "1px solid #E5E7EB",
                        borderRadius: "8px 8px 0 0 ",
                    }}
                >
                    <ContactDetailsIcon />
                    <SecondaryTypography>Edit Admin Details</SecondaryTypography>
                </Stack>

                <Grid
                    container
                    xs={12}
                    gap="2.8%"
                    sx={{
                        backgroundColor: "white",
                        padding: "30px 16px 30px 16px",
                        border: "1px solid #E5E7EB",
                        borderRadius: "0 0 8px 8px",
                    }}
                >
                    {/* Name */}
                    <Grid xs={12} sm={5.8}>
                        <StyledTypography>Admin Name</StyledTypography>
                        <TextField
                            name="name"
                            value={adminData.name}
                            onChange={handleInputChange}
                            inputProps={{ maxLength: 70 }}
                            InputProps={{ disableUnderline: true }}
                            sx={{
                                "& .MuiInputBase-root": {
                                    color: errtext.name ? "#912018" : "#111927",
                                },
                                backgroundColor: errtext.name ? "#FEE4E2" : "#F9FAFB",
                            }}
                            fullWidth
                        />
                        <ErrorTypography>{errtext.name}</ErrorTypography>
                    </Grid>

                    {/* Email - Read Only */}
                    <Grid xs={12} sm={5.8}>
                        <StyledTypography>Email</StyledTypography>
                        <TextField
                            name="email"
                            value={adminData.email}
                            disabled={true}
                            InputProps={{ disableUnderline: true }}
                            sx={{
                                "& .MuiInputBase-root": {
                                    color: "#111927",
                                },
                                backgroundColor: "#F9FAFB",
                            }}
                            fullWidth
                        />
                        <ErrorTypography>{errtext.email}</ErrorTypography>
                    </Grid>

                    {/* Phone */}
                    <Grid xs={12} sm={5.8} mt={2}>
                        <StyledTypography>Phone</StyledTypography>
                        <PhoneInput
                            country={"sg"}
                            value={adminData.phone.replace(/^\+/, '')}
                            onChange={(phoneValue) => handleInputChange(phoneValue, "phone")}
                            inputStyle={{
                                width: "100%",
                                height: "56px",
                                backgroundColor: errtext.phone ? "#FEE4E2" : "#F9FAFB",
                                border: "0px solid #D0D5DD",
                                borderRadius: "8px",
                                color: errtext.phone ? "#912018" : "#111927",
                                fontSize: "16px",
                                paddingLeft: "48px",
                            }}
                            buttonStyle={{
                                border: "0px solid #D0D5DD",
                                backgroundColor: "#F9FAFB",
                                borderTopLeftRadius: "8px",
                                borderBottomLeftRadius: "8px",
                            }}
                            specialLabel=""
                            inputProps={{ maxLength: 20 }}
                        />
                        <ErrorTypography>{errtext.phone}</ErrorTypography>
                    </Grid>

                    {/* Onboard Date */}
                    <Grid xs={12} sm={5.8} mt={2}>
  <StyledTypography>Admin Onboard Date</StyledTypography>

  <DatePicker
    format="DD/MM/YYYY"
    slots={{
      openPickerIcon: () => <DatePickerIcon />,
    }}
    name="on_board_date"
    value={
      adminData.on_board_date
        ? dayjs(adminData.on_board_date)
        : null
    }
    minDate={dayjs()} // Prevent past dates
    maxDate={dayjs().add(3, "month")} // Optional limit
    onChange={(newValue) =>
      handleInputChange(newValue, "on_board_date")
    }
    sx={{
      ...DatePickerStyle,
      backgroundColor: errtext.on_board_date
        ? "#FEE4E2"
        : "",
      "& .MuiInputBase-root": {
        color: errtext.on_board_date
          ? "#912018"
          : "#111927",
      },
    }}
  />

  <ErrorTypography>
    {errtext.on_board_date}
  </ErrorTypography>
</Grid>

                    {/* Offboard Date */}
                    <Grid xs={12} sm={5.8} mt={2}>
                        <StyledTypography>Admin Offboard Date</StyledTypography>
                        <DatePicker
                            format="DD/MM/YYYY"
                            slots={{
                                openPickerIcon: () => <DatePickerIcon />,
                            }}
                            minDate={adminData.on_board_date ? dayjs(adminData.on_board_date) : dayjs()}
                            name="off_board_date"
                            value={adminData.off_board_date ? dayjs(adminData.off_board_date) : null}
                            onChange={(newValue) => handleInputChange(newValue, "off_board_date")}
                            sx={{
                                ...DatePickerStyle,
                                backgroundColor: errtext.off_board_date ? "#FEE4E2" : "",
                                "& .MuiInputBase-root": {
                                    color: errtext.off_board_date ? "#912018" : "#111927",
                                },
                            }}
                        />
                        <ErrorTypography>{errtext.off_board_date}</ErrorTypography>
                    </Grid>
                </Grid>

                <Box bgcolor="#FFFFFF" sx={{ border: "1px solid #E5E7EB", borderRadius: '8px 8px 8px 8px', mt: 2 }}>
                    <Stack direction="column" justifyContent='end' alignItems='end' sx={{ py: 2, px: 2, display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                        <Button type='button' onClick={() => navigate(-1)} sx={{ fontWeight: '600', width: "100px", color: '#800000', backgroundColor: "#f3eae7ff" }}>Back</Button>
                        <Button type='button' disabled={loading} onClick={handleUpdate} sx={{ fontWeight: '600', width: "100px", color: 'white', backgroundColor: "#800000", "&:hover": {
                            backgroundColor: "#660000",
                        }, "&.Mui-disabled": {
                            backgroundColor: "#C4C4C4",
                            color: "#6B7280",
                            cursor: "not-allowed",
                        } }}>Update</Button>
                    </Stack>
                </Box>
            </Box>
        </>
    );
}

export default EditAdmin;